import 'Shared/util';
import HSHeader from 'Lib/unify/vendor/hs-header/src/js/hs-header';
import HSMegaMenu from 'Lib/unify/vendor/hs-mega-menu/src/js/hs-mega-menu';

//const shrink = "r-header-fix";

export default class Header {
    constructor(options = {
        id: "site-header",
        headerOffsetTop: 100
    })
    {
        this.options = options;

        const elHeader = this.#element;
        if (elHeader) {
            new HSHeader(elHeader).init();
        }

        new HSMegaMenu('.js-mega-menu');
    }

    get #element() {
        return document.getElementById(this.options.id);
    }
}

DOMTokenList.prototype.toggleIf = function (condition, token)
{
    if (condition) {
        this.add(token);
    } else {
        this.remove(token);
    }
}